import React, { useContext } from 'react';
import { Typography, Row, Col, Alert, Divider } from 'antd';
import { ViewDocument } from '../../../../components';
import { Context } from '../../../../defaults';
import * as Questions from './types';



const { Title } = Typography;

const Question = ({ data, setData, student, setDisableNav, current }) => {
    const { dictionary, language } = useContext(Context);
    const Question = Questions[`Question${data.question.questionTypeId}`];

    return (
        <div style={{ marginTop: '30px' }} >
            <Row style={{ marginBottom: 50 }}>
                <Col span={24}>
                    {`${student.lastName} ${student.firstName} ${student.middleName}`}
                </Col>
            </Row>
            {
                data.question.questionText &&
                <Row gutter={16} style={{ marginBottom: 50 }}>
                    <Col>
                        <Title level={3}>{data.question.questionText}</Title>
                    </Col>
                </Row>
            }
            {
                data?.question?.files &&
                <div style={{ marginBottom: 50 }}>
                    <ViewDocument files={data.question.files} />
                </div>
            }
            {
                data.question.questionHtml &&
                <Row gutter={16} style={{ marginBottom: 50 }}>
                    <Col>
                        <p style={{ wordWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: data.question.questionHtml }} />
                    </Col>
                </Row>
            }

            <Divider orientation='center'>{dictionary?.Answer[language]}</Divider>

            {
                data.question.questionTypeId &&
                <Question data={data} setData={setData} setDisableNav={setDisableNav} current={current} />
            }
            {
                data.question.questionTypeId !== 2 &&
                <div style={{ marginTop: 30 }}>
                    <Alert message={data.studentAnswer?.isRight === 1 ? dictionary?.RightAnswer[language] + ". " + dictionary?.Score[language] + ": " + data.studentAnswer.point + "/" + data.question.point : dictionary?.NotRightAnswer[language] + ". " + dictionary?.Score[language] + ": " + data.studentAnswer.point + "/" + data.question.point} type={data.studentAnswer?.isRight === 1 ? 'success' : 'error'} showIcon />
                </div>
            }

            {
                data.studentAnswer.usedHint === 1 &&
                <div style={{ marginTop: 30 }}>
                    <Alert message={dictionary?.HintUsed[language]} type={'warning'} showIcon />
                </div>
            }
        </div >
    );
}

export default Question;